import loadable from '@loadable/component';

export const DealCountdown = loadable(
  () => import(/* webpackChunkName: 'deal-countdown' */ './DealCountdown'),
);
